import React, { useState, useEffect } from 'react'
import "./Admins.css";
import Popup from 'reactjs-popup';
import DataTableComponent from "../../../../../Util/DataTable/DataTable";
import AddEditAdminModal from './Modals/AddEditAdminModal';
import { config } from '../../../../../config';
import { BACK_DROP_FALSE, formatPhoneNumber } from '../../../../../Util/helper';
import add from "../../../../../assets/add-icon.svg";
import axiosApi from '../../../../../core/interceptor/interceptor';
import { useSelector } from 'react-redux';
import { permissions } from '../../../../../Store/reducers/PermissionsReducer';
import * as moment from 'moment';

const columns = [
	{
		name: <div className="table-header" style={{ padding: '5px 6px 5px 15px', textAlign: 'left', wordBreak: 'break-word' }}>Name</div>,
		selector: () => 'first_name',
		className: 'left-align',
		minWidth: '130px !important',
		sortable: 'true',
		style: {
			padding: '0'
		},
		cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', textAlign: 'left', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.first_name && row.last_name ? `${row.first_name} ${row.last_name}` : 'N/A'}</div>)
	},
	{
		name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Email</div>,
		selector: () => 'email',
		minWidth: '160px !important',
		sortable: 'true',
		style: {
			padding: '0',
			whiteSpace: 'pre-wrap !important'
		},
		cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', justifyContent: 'flex-start !important', textAlign: 'left', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.email ? row.email : 'N/A'}</div>)
	},
	{
		name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'center', wordBreak: 'break-word' }}>Primary Phone</div>,
		selector: () => 'cell_phone',
		minWidth: '130px !important',
		sortable: 'true',
		style: {
			padding: '0'
		},
		cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.cell_phone ? formatPhoneNumber(row.cell_phone) : 'N/A'}</div>)
	},
	{
		name: <div className="table-header" style={{ padding: '8px 10px', wordBreak: 'break-word' }}>Secondary Phone</div>,
		selector: () => 'secondary_phone',
		minWidth: '136px !important',
		sortable: 'true',
		style: {
			padding: '0'
		},
		cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.secondary_phone ? formatPhoneNumber(row.secondary_phone) : 'N/A'}</div>)
	},
	{
		name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'center', wordBreak: 'break-word' }}>Locked</div>,
		selector: () => 'account_locked',
		minWidth: '98px !important',
		sortable: 'true',
		style: {
			padding: '0'
		},
		cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.account_locked ? 'True' : 'False'}</div>)
	},
  {
    name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Last Logged In</div>,
    selector: () => 'last_logged_in_at',
    minWidth: '98px !important',
    sortable: 'true',
    style: {
      padding: '0'
    },
    cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.last_logged_in_at ? moment(row.last_logged_in_at).format('M/DD/YYYY hh:mm A') : 'N/A'}</div>)
  },
];

const userType = 'admin'

export default function Admin() {
	const permission = useSelector(permissions);
	const [open, setOpen] = useState(false);
	const [adminData, setAdminData] = useState([]);
	const [totalPage, setTotalPage] = useState(0);
	const [userDetail, setUserDtail] = useState({
		first_name: '',
		last_name: '',
		cell_phone: '',
		email: '',
		direction: 'desc',
		sort_column: '',
		page: 1,
		limit: 50,
	});
	const [loader, setLoader] = useState(true);

	useEffect(() => {
		getAdmin();
		//eslint-disable-next-line
	},[
			userDetail.page,
			userDetail.limit,
			userDetail.direction,
			userDetail.sort_column
		]
	);

	/**** Closes Modal ****/
	const closeModal = (resp = false) => {
		setOpen(false);
		if (resp) {
			getAdmin();
		}
	};
	const getAdmin = () => {
		setLoader(true);
		axiosApi.get(`${config.apiUrl}/users/${userType}`, { params: userDetail })
			.then((response) => {
				setAdminData(response.data.data);
				setTotalPage(response.data.total);
				setLoader(false);
			})
			.catch((err) => {
				setLoader(false);
			});
	}

	const handleChange = (e) => {
		let stateFunc = null;
		if (e.type === 'sort') {
			stateFunc = (prevValue) => ({
				...prevValue,
				[e.target.name]: e.target.value,
				'direction': e.target.direction,
			})
		} else {
			stateFunc = (prevValue) => ({
				...prevValue,
				[e.target.name]: e.target.value,
			})
		}
		setUserDtail(stateFunc);
	}

	return <>
		<div className="table-wrapper table-wrapper-admin">
			<div className="heading-blk">
				<div className="left">
					<h2>Administrators</h2>
					<p>Administrators have access to select admin features.{permission.includes('users_modify_admin') && ' Select a user to modify access.'}</p>
				</div>
				{
					permission.includes('users_modify_admin') &&
					<div className="right">
						<button onClick={() => setOpen(o => !o)}><img src={add} alt='add-logo'/>Add Admin</button>
					</div>
				}
			</div>
			<div className="dataTable">
				<DataTableComponent
					loading={loader}
					key="table-admin-admins"
					type={'admin'}
					data={adminData}
					columns={columns}
					onFilterChange={handleChange}
					refresh={() => getAdmin()}
					totalPage={totalPage}
					limit={userDetail.limit} />
			</div>
		</div>
		<Popup open={open} onClose={closeModal} closeOnDocumentClick={BACK_DROP_FALSE}>
			<AddEditAdminModal closeModal={(resp) => {
				if (resp) {
					getAdmin();
				}
				closeModal();
			}} />
		</Popup>
	</>
}
